import apiClient from './client'

/**
 * 支付相关 API
 */
export const paymentApi = {
  /**
   * 查询 Telegram Stars 支付开关（与后端 TELEGRAM_STARS_ENABLED 同步）
   */
  getStarsPaymentConfig(config = {}) {
    return apiClient.get('/telegram/stars/config', config)
  },

  /**
   * 查询 AIX Pay RUB 支付配置
   */
  getAixPayConfig(config = {}) {
    return apiClient.get('/aixpay/config', config)
  },

  /**
   * 创建 Telegram Stars 支付 invoice
   * @param {Object} data
   * @param {string} data.order_no - 订单号
   */
  createStarsPaymentOrder(data) {
    return apiClient.post('/telegram/stars/pay/order', data)
  },

  /**
   * 创建 AIX Pay 支付订单
   * @param {Object} data
   * @param {string} data.order_no - 订单号
   * @param {string} data.way_code - AIX wayCode
   */
  createAixPaymentOrder(data) {
    return apiClient.post('/aixpay/pay/order', data)
  },

  /**
   * 创建支付订单
   * @param {Object} data - 支付数据
   * @param {string} data.order_no - 订单号
   * @returns {Promise} 支付响应
   */
  createPaymentOrder(data) {
    return apiClient.post('/cobo/pay/order', data)
  },

  /**
   * 查询支付状态
   * @param {string} orderNo - 订单号
   * @returns {Promise} 支付状态响应
   */
  getPaymentStatus(orderNo) {
    return apiClient.get(`/cobo/pay/status/${orderNo}`)
  },

  /**
   * 使用积分购买
   * @param {Object} data - 购买数据
   * @param {string} data.userid - 用户ID
   * @param {string} data.productId - 产品ID
   * @returns {Promise} 购买响应
   */
  purchaseWithScore(data) {
    return apiClient.post('/purchase-with-score/', data)
  }
}
